import Vue from 'vue'
import VueRouter from 'vue-router'
////
//import HelloWorld from '../components/HelloWorld.vue'
import AuthFail from '../components/AuthFail.vue'
import Login from '../components/Login.vue'
import SignIn from '../components/SignIn.vue'
import DashBoard from '../components/DashBoard.vue'
import ImageUploaderUtil from '../components/ImageUploaderUtil.vue'




///[통계 관리]
import ImgQuizLogView from '../components/report/ImgQuizLogView.vue'
import ImgQuizLogView_Visit from '../components/report/ImgQuizLogView_Visit.vue'

import PreReservation_Regist from '../components/report/PreReservation_Regist.vue'
import PreReservation_Setting from '../components/report/PreReservation_Setting.vue'

///[광고 관리]
import Advertisement_List from '../components/advertisement/Advertisement_List.vue'
import Advertisement_Regist from '../components/advertisement/Advertisement_Regist.vue'
import Advertisement_Statistics from '../components/advertisement/Advertisement_Statistics.vue'
import Advertisement_House from '../components/advertisement/Advertisement_House.vue'
import HouseAd_AppList from '../components/advertisement/HouseAd_AppList.vue'
import HouseAd_RewardType from '../components/advertisement/HouseAd_RewardType.vue'
import HouseAd_AdManage from '../components/advertisement/HouseAd_AdManage.vue'
import HouseAd_Participation from '../components/advertisement/HouseAd_Participation.vue'
import HouseAd_Manage from '../components/advertisement/HouseAd_Manage.vue'
import Store_Main from '../components/store/Store_Main.vue'
import PhoneAuth_Logs from '../components/phone_auth/PhoneAuth_Logs.vue'
import Coupon_Products from '../components/coupon/Coupon_Products.vue'
import Coupon_Categories from '../components/coupon/Coupon_Categories.vue'
import Coupon_Placements from '../components/coupon/Coupon_Placements.vue'
import Coupon_Orders from '../components/coupon/Coupon_Orders.vue'

///[결제 관리]
import Billing_Dash from '../components/billing/Billing_Dash.vue'
import Billing_Project from '../components/billing/Billing_Project.vue'
import Billing_Statistics from '../components/billing/Billing_Statistics.vue'



///[ETC]
import NotFound from '../components/NotFound.vue'



/// [ 스냅퀴즈 ]
import QuizList from '../components/snapquiz/QuizList.vue'
import QuizEdit from '../components/snapquiz/QuizEdit.vue'
import QuizList_Ad_Bundle from '../components/snapquiz/QuizList_Ad_Bundle.vue'
import QuizNotice from '../components/snapquiz/Quiz_Notice.vue'
import QuizNoticeWrite from '../components/snapquiz/Quiz_Notice_Write.vue'
import QuizList_Group from '../components/snapquiz/QuizList_Group.vue'


import TestList from '../components/snapquiz/TestList.vue'
import TestEdit from '../components/snapquiz/TestEdit.vue'

import PartnerMain from '../components/partner/PartnerMain.vue'
import PartnerTemplate from '../components/partner/PartnerTemplate.vue'

import Quiz_Sample from '../components/snapquiz/Quiz_Sample.vue'
import QuizUploader from '../components/snapquiz/QuizUploader.vue'
import Quiz_Setting from '../components/snapquiz/Quiz_Setting.vue'
import SnapQuiz_RewardAd_Dashboard from '../components/snapquiz/RewardAd_Dashboard.vue'
import SnapQuiz_RewardAd_Manage from '../components/snapquiz/RewardAd_Manage.vue'


///[CPU Project 관리 ]

import CPU_Dashboard from '../components/cpu/Game_Dashboard.vue'
import CPU_User_Info from '../components/cpu/User_Info.vue'
import CPU_User_List from '../components/cpu/User_List.vue'
import CPU_Mail from '../components/cpu/Game_Mail.vue'
import CPU_Coupon from '../components/cpu/Game_Coupon.vue'
import CPU_Setting from '../components/cpu/Game_Setting.vue'
import CPU_TokenContent from '../components/cpu/Game_TokenContent.vue'
import CPU_Template from '../components/cpu/Game_Template.vue'
import CPU_Notice from '../components/cpu/Game_Notice.vue'
import Game_Notice_Write from '../components/cpu/Game_Notice_Write.vue'
import CPU_Data from '../components/game/Game_Chat.vue'

import CPU_CoinProduct from '../components/cpu/Game_CoinProduct.vue'
import CPU_CoinOrderList from '../components/cpu/Game_CoinOrderList.vue'
import CPU_CashOrderList from '../components/cpu/Game_CashOrderList.vue'

// import ErrorLog_List from '../components/game/ErrorLog_List.vue'
import CPU_Game_YT_EventManage from '../components/cpu/Game_YT_EventManage.vue'
import CPU_UserBuyProducts from '../components/cpu/Game_UserBuyProducts.vue'
import CPU_Exchange from '../components/cpu/Game_Exchange.vue'
import CPU_EventNoti from '../components/cpu/Game_EventNoti.vue'
import Carrygold_EventNoti from '../components/carrygold/Game_EventNoti.vue'
import CPU_EventRolling from '../components/cpu/Game_EventRolling.vue'
import CPU_EventVerify from '../components/cpu/Game_Event_Verify.vue'
import CPU_ApiTester from '../components/cpu/ApiTester.vue'







//*** [QuizNCash Project 관리 ]

import QuizCash_Dashboard from '../components/quizncash/Game_Dashboard.vue'
import QuizCash_EventVerify from '../components/quizncash/Game_Event_Verify.vue'
import QuizCash_MainQuizInfo from '../components/quizncash/Game_MainQuizInfo.vue'
import QuizCash_User_Info from '../components/quizncash/User_Info.vue'
import QuizCash_User_List from '../components/quizncash/User_List.vue'
import QuizCash_Mail from '../components/quizncash/Game_Mail.vue'
import QuizCash_Coupon from '../components/quizncash/Game_Coupon.vue'
import QuizCash_Setting from '../components/quizncash/Game_Setting.vue'
import QuizCash_Notice from '../components/quizncash/Game_Notice.vue'
import QuizCash_Notice_Write from '../components/quizncash/Game_Notice_Write.vue'
import QuizCash_CoinProduct from '../components/quizncash/Game_CoinProduct.vue'
import QuizCash_CashOrderList from '../components/quizncash/Game_CashOrderList.vue'
import QuizCash_Game_YT_EventManage from '../components/quizncash/Game_YT_EventManage.vue'
import QuizCash_UserBuyProducts from '../components/quizncash/Game_UserBuyProducts.vue'
import QuizCash_EventRolling from '../components/quizncash/Game_EventRolling.vue'



//*** [포인트공장 Project 관리 ]

import PntFactory_Dashboard       from '../components/pnt_factory/Game_Dashboard.vue'
import PntFactory_UserList        from '../components/pnt_factory/User_List.vue'
import PntFactory_UserInfo        from '../components/pnt_factory/User_Info.vue'
import PntFactory_DevUtil         from '../components/pnt_factory/DevUtil.vue'
import PntFactory_Mail            from '../components/pnt_factory/Game_Mail.vue'
import PntFactory_Coupon          from '../components/pnt_factory/Game_Coupon.vue'
import PntFactory_Notice          from '../components/pnt_factory/Game_Notice.vue'
import PntFactory_NoticeWrite     from '../components/pnt_factory/Game_Notice_Write.vue'
import PntFactory_CoinProduct     from '../components/pnt_factory/Game_CoinProduct.vue'
import PntFactory_CashOrderList   from '../components/pnt_factory/Game_CashOrderList.vue'
import PntFactory_UserBuyProducts from '../components/pnt_factory/Game_UserBuyProducts.vue'
import PntFactory_EventNoti       from '../components/pnt_factory/Game_EventNoti.vue'
import PntFactory_Setting         from '../components/pnt_factory/Game_Setting.vue'
import PntFactory_ApiTester       from '../components/pnt_factory/ApiTester.vue'
//*** [돈만농 Project 관리 ] — pnt_factory 복사본
import Mandoora_Dashboard       from '../components/mandoora/Game_Dashboard.vue'
import Mandoora_UserList        from '../components/mandoora/User_List.vue'
import Mandoora_UserInfo        from '../components/mandoora/User_Info.vue'
import Mandoora_DevUtil         from '../components/mandoora/DevUtil.vue'
import Mandoora_Mail            from '../components/mandoora/Game_Mail.vue'
import Mandoora_Coupon          from '../components/mandoora/Game_Coupon.vue'
import Mandoora_Notice          from '../components/mandoora/Game_Notice.vue'
import Mandoora_NoticeWrite     from '../components/mandoora/Game_Notice_Write.vue'
import Mandoora_CoinProduct     from '../components/mandoora/Game_CoinProduct.vue'
import Mandoora_CashOrderList   from '../components/mandoora/Game_CashOrderList.vue'
import Mandoora_UserBuyProducts from '../components/mandoora/Game_UserBuyProducts.vue'
import Mandoora_EventNoti       from '../components/mandoora/Game_EventNoti.vue'
import Mandoora_Setting         from '../components/mandoora/Game_Setting.vue'
import Mandoora_ApiTester       from '../components/mandoora/ApiTester.vue'


//*** [금나르기 Project 관리 ]

import CarryGold_Dashboard from '../components/carrygold/Game_Dashboard.vue'
import CarryGold_User_Info from '../components/carrygold/User_Info.vue'
import CarryGold_Auth_Recover from '../components/carrygold/Auth_Recover.vue'
import CarryGold_User_List from '../components/carrygold/User_List.vue'
import CarryGold_Mail from '../components/carrygold/Game_Mail.vue'
import CarryGold_Coupon from '../components/carrygold/Game_Coupon.vue'
import CarryGold_Setting from '../components/carrygold/Game_Setting.vue'
import CarryGold_Notice from '../components/carrygold/Game_Notice.vue'
import CarryGold_Notice_Write from '../components/carrygold/Game_Notice_Write.vue'
import CarryGold_CoinProduct from '../components/carrygold/Game_CoinProduct.vue'
import CarryGold_CashOrderList from '../components/carrygold/Game_CashOrderList.vue'
import CarryGold_GoldOrderList from '../components/carrygold/Game_GoldOrderList.vue'
import CarryGold_GoldExchange from '../components/carrygold/Game_GoldExchange.vue'
import CarryGold_Game_YT_EventManage from '../components/carrygold/Game_YT_EventManage.vue'
import CarryGold_UserBuyProducts from '../components/carrygold/Game_UserBuyProducts.vue'
import CarryGold_DevUtil from '../components/carrygold/DevUtil.vue'
import CarryGold_Notice_GoldVerify from '../components/carrygold/Game_Notice_GoldVerify.vue'
import CarryGold_ChatManage from '../components/carrygold/Game_ChatManage.vue'
import CarryGold_RouletteEvent from '../components/carrygold/Game_RouletteEvent.vue'




//*** [단타의 신 Project 관리 ]

import Danta_Dashboard from '../components/danta/Game_Dashboard.vue'
import Danta_GameInProgress from '../components/danta/Game_InProgress.vue'
import Danta_GameManage from '../components/danta/Game_Manage.vue'
import Danta_CallbackMonitor from '../components/danta/Callback_Monitor.vue'
import Danta_UserList from '../components/danta/User_List.vue'
import Danta_Setting from '../components/danta/Game_Setting.vue'
import Danta_DebugTest from '../components/danta/Debug_Test.vue'
import Danta_GameTemplateManage from '../components/danta/Game_Template_Manage.vue'
import Danta_ManualRoundManage from '../components/danta/Manual_Round_Manage.vue'
import Danta_ClientList from '../components/danta/Client_List.vue'
import Danta_MediaManage from '../components/danta/Media_Manage.vue'
import Danta_GameRoundDetail from '../components/danta/Game_Round_Detail.vue'
import Danta_StatsIndex      from '../components/danta/Stats_Index.vue'
import Danta_StatsToday      from '../components/danta/Stats_Today.vue'
import Danta_StatsDaily      from '../components/danta/Stats_Daily.vue'
import Danta_StatsMonthly    from '../components/danta/Stats_Monthly.vue'
import Danta_StatsMedia      from '../components/danta/Stats_Media.vue'
import Danta_StatsCronStatus from '../components/danta/Stats_CronStatus.vue'

//*** [프롬프트 마스터 — 로컬 전용 도구 ]
// 등록(Regist) 컴포넌트는 라우트가 아니라 List(=관리) 페이지의 다이얼로그로만 사용된다.
// [프롬북] 페이지들은 src/components/prombook/ 폴더로 이동됨 (옛 prompt_master 폴더는 폐기)

///[프롬북]
import Prombook_PromptList     from '../components/prombook/Prompt_List.vue'
import Prombook_FeedList       from '../components/prombook/Feed_List.vue'
import Prombook_UserList       from '../components/prombook/User_List.vue'
import Prombook_NoticeList     from '../components/prombook/Notice_List.vue'
import Prombook_NoticeWrite    from '../components/prombook/Notice_Write.vue'
import Prombook_EventList      from '../components/prombook/Event_List.vue'
import Prombook_BuyProductList from '../components/prombook/BuyProduct_List.vue'
import Prombook_Setting        from '../components/prombook/Setting.vue'
import Prombook_Mail           from '../components/prombook/Game_Mail.vue'
import Prombook_ApiTester      from '../components/prombook/ApiTester.vue'


//CMS
import CMSUserTab from '../components/cms_user/CMSUserTab.vue'
import CMSUserManagedHome from '../components/cms_user/CMSUserManagedHome.vue'
import CMSLogInfo from '../components/cms_log/CMSLogInfo.vue'








import store from '../store';
import config from '../config/config';
import JsonExcel from 'vue-json-excel';

Vue.use(VueRouter);
//Vue.use(DatetimePicker);

Vue.component('downloadExcel', JsonExcel);

const requireAuth = (to, from, next) => {
    const loginPath = `/login?rPath=${encodeURIComponent(to.path)}`;
    const { session_id, user_id, user_level, session_time } = localStorage;

    console.log(session_id, user_id, user_level, store.getters.isAuth, session_time);
    // store.commit('LOGIN', { session_id, user_id, user_level } || {});
    // 1이상만 통과할 수 있게 해두고,
    // 0 이면 권한없음 페이지로 날리자.
    let level = parseInt(user_level);
    //console.log(`Justin test user_level : ${level} || ${level >= 0} || ${level === 0}`);
    if (!(level >= 0)) return next(loginPath);
    if (level === 0) {
        store.commit('LOGOUT');
        return next('/auth_fail');

    }
    store.commit('LOGIN_CHECK');
    return store.getters.isAuth ? next() : next(loginPath);
}
const sessionCheck = (to, from, next) => {
    const { session_id, user_id, user_level, session_time } = localStorage;
    //console.log(JSON.stringify(store.getters));
    if (store.getters.isAuth) {
        alert('already login ' + store.getters.isAuth);
        return;
    }
    return next();
}
const devCheck = (to, from, next) => {
    // console.log(config.isLocal);
    // console.log('JS ', config.isJS );
    // console.log(location.host);

    if (config.isDev || config.isLocal || config.isJS) {
        return next();
    }
    else {
        alert('DEV CMS 에서만 사용가능.');
        return;
    }
}

const router = new VueRouter({
    mode: 'history',
    routes: [
        {//CMS 로그인하려할때 
            path: '/login',
            component: Login,
            beforeEnter: sessionCheck,
        },
        {//로그인 실패 했을때 
            path: '/auth_fail',
            component: AuthFail,
            beforeEnter: sessionCheck,
        },
        {// 새로 가입하려는 경우 
            path: '/sign_in',
            component: SignIn,
            beforeEnter: sessionCheck,
        },
        {
            path: '/dashboard',
            component: DashBoard,
            beforeEnter: requireAuth,
        },
        {
            path: '/image_uploader_util',
            component: ImageUploaderUtil,
            beforeEnter: requireAuth,
        },

        // {//유저 리스트 ---> 여기서 우편 보내기 기능이 되었으면 좋겠다. 
        //     path: '/user_list',
        //     component: User_List,
        //     beforeEnter: requireAuth,
        // },  
        // {//유저정보관리 
        //     path: '/user_info',
        //     component: User_Info,
        //     beforeEnter: requireAuth,
        // },  
        // {//유저에게 우편 보내기 // 여기에서 우편 포맷 보내기도 설정하도록 한다 개발자마다 설정이 다를 수 있으니 이 부분 설정하도록 
        //     path: '/game_mail',
        //     component: Game_Mail,
        //     beforeEnter: requireAuth,
        // },          
        // {//쿠폰 발급하기 --> 타겟 유저에게 쿠폰 발급하거나 게임 전체에 발급하도록 한다 
        //     path: '/game_coupon',
        //     component: Game_Coupon,
        //     beforeEnter: requireAuth,
        // },          
        // {//게임서버 설정 -> 점검 상태 , 업데이트 유도 등등 
        //     path: '/game_template',
        //     component: Game_Template,
        //     beforeEnter: requireAuth,
        // },
        // {//게임서버 설정 -> 점검 상태 , 업데이트 유도 등등 
        //     path: '/game_setting',
        //     component: Game_Setting,
        //     beforeEnter: requireAuth,
        // },
        // {//게임서버 설정 -> 채팅관리
        //     path: '/game_chat',
        //     component: Game_Chat,
        //     beforeEnter: requireAuth,
        // },        


        {//유저 사전예약 통계 셋팅
            path: '/pre_reservation_setting',
            component: PreReservation_Setting,
            beforeEnter: requireAuth,
        },

        {//광고 리스트
            path: '/advertisement_list',
            component: Advertisement_List,
            beforeEnter: requireAuth,
        },
        {//광고등록 및 수정
            path: '/advertisement_regist',
            component: Advertisement_Regist,
            beforeEnter: requireAuth,
        },
        {//광고 통계관리
            path: '/advertisement_statistics',
            component: Advertisement_Statistics,
            beforeEnter: requireAuth,
        },
        {//하우스 애드 (광고 리스트 + 통계)
            path: '/advertisement_house',
            component: Advertisement_House,
            beforeEnter: requireAuth,
        },
        {//하우스 애드 앱관리
            path: '/advertisement_house_app_list',
            component: HouseAd_AppList,
            beforeEnter: requireAuth,
        },
        {//하우스 애드 보상 타입 관리
            path: '/advertisement_house_reward_type',
            component: HouseAd_RewardType,
            beforeEnter: requireAuth,
        },
        {//하우스 애드 광고 관리 (보상은 여기서만 설정)
            path: '/advertisement_house_ad_manage',
            component: HouseAd_Manage,
            beforeEnter: requireAuth,
        },
        {//하우스 애드 참여정보
            path: '/advertisement_house_participation',
            component: HouseAd_Participation,
            beforeEnter: requireAuth,
        },
        {//스토어 (쿠폰 4화면 탭 통합) — 메뉴 진입점
            path: '/store',
            component: Store_Main,
            beforeEnter: requireAuth,
        },
        {//전화번호 인증 (인증요청 목록·검색·포스트백 재전송)
            path: '/phone_auth',
            component: PhoneAuth_Logs,
            beforeEnter: requireAuth,
        },
        // 아래 쿠폰 4개 경로는 메뉴에서 빠졌지만 직접 접근/기존 북마크용으로 남겨둔다
        {//쿠폰 상품 관리
            path: '/coupon_products',
            component: Coupon_Products,
            beforeEnter: requireAuth,
        },
        {//쿠폰 카테고리 관리
            path: '/coupon_categories',
            component: Coupon_Categories,
            beforeEnter: requireAuth,
        },
        {//쿠폰 노출(플레이스먼트) 관리
            path: '/coupon_placements',
            component: Coupon_Placements,
            beforeEnter: requireAuth,
        },
        {//쿠폰 주문/매출
            path: '/coupon_orders',
            component: Coupon_Orders,
            beforeEnter: requireAuth,
        },
        {//결제 데시보드
            path: '/billing_dash',
            component: Billing_Dash,
            beforeEnter: requireAuth,
        },
        {//결제 프로젝트
            path: '/billing_project',
            component: Billing_Project,
            beforeEnter: requireAuth,
        },
        {//결제 통계
            path: '/billing_statistics',
            component: Billing_Statistics,
            beforeEnter: requireAuth,
        },







        {
            path: '/quizlist',
            component: QuizList,
            beforeEnter: requireAuth,
        },
        {
            path: '/quizlist_group',
            component: QuizList_Group,
            beforeEnter: requireAuth,
        },

        {
            path: '/quizedit',
            component: QuizEdit,
            beforeEnter: requireAuth,
        },
        {
            path: '/testlist',
            component: TestList,
            beforeEnter: requireAuth,
        },
        {
            path: '/testedit',
            component: TestEdit,
            beforeEnter: requireAuth,
        },
        {
            path: '/quizsample',
            component: Quiz_Sample,
            beforeEnter: requireAuth,
        },
        {
            path: '/quizlist_adbundle',
            component: QuizList_Ad_Bundle,
            beforeEnter: requireAuth,
        },
        {
            path: '/partner',
            component: PartnerMain,
            beforeEnter: requireAuth,
        },
        {
            path: '/partner_template',
            component: PartnerTemplate,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/img_quiz_log',
            component: ImgQuizLogView,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/img_quiz_log_visit',
            component: ImgQuizLogView_Visit,
            beforeEnter: requireAuth,
        },
        {
            path: '/quiz_notice',
            component: QuizNotice,
            beforeEnter: requireAuth,
        },
        {
            path: '/quiz_notice_write',
            component: QuizNoticeWrite,
            beforeEnter: requireAuth,
        },
        {
            path: '/quiz_uploader',
            component: QuizUploader,
            beforeEnter: requireAuth,
        },
        {//스냅퀴즈 서버 설정 (Git Patch / 서버 응답 확인)
            path: '/quiz_setting',
            component: Quiz_Setting,
            beforeEnter: requireAuth,
        },
        {//스냅퀴즈 보상형 하우스애드 대시보드
            path: '/quiz_dash_board',
            component: SnapQuiz_RewardAd_Dashboard,
            beforeEnter: requireAuth,
        },
        {//스냅퀴즈 보상형 하우스애드 관리
            path: '/quiz_reward_ad',
            component: SnapQuiz_RewardAd_Manage,
            beforeEnter: requireAuth,
        },






        //////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /// 채굴기 라우터 설정 
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////
        {
            path: '/cpu_dash_board',
            component: CPU_Dashboard,
            beforeEnter: requireAuth,
        },
        {//[API 테스터] 포인트 채굴기
            path: '/cpu/api_tester',
            component: CPU_ApiTester,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/cpu_user_list',
            component: CPU_User_List,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/cpu_user_info',
            component: CPU_User_Info,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/cpu_mail',
            component: CPU_Mail,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/cpu_coupon',
            component: CPU_Coupon,
            beforeEnter: requireAuth,
        },
        {//이벤트 롤링 관리
            path: '/cpu_event_rolling',
            component: CPU_EventRolling,
            beforeEnter: requireAuth,
        },
        {//유저 이벤트 검수
            path: '/cpu_event_verify',
            component: CPU_EventVerify,
            beforeEnter: requireAuth,
        },
        {//토큰 컨텐츠(토큰 경매) 관리
            path: '/cpu_token_content',
            component: CPU_TokenContent,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/cpu_setting',
            component: CPU_Setting,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/cpu_notice',
            component: CPU_Notice,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/cpu_notice_write',
            component: Game_Notice_Write,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/cpu_template',
            component: CPU_Template,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/cpu_data',
            component: CPU_Data,
            beforeEnter: requireAuth,
        },
        {//코인상품 관리
            path: '/cpu_coin_product',
            component: CPU_CoinProduct,
            beforeEnter: requireAuth,
        },
        {//코인주문 관리 
            path: '/cpu_coin_order_list',
            component: CPU_CoinOrderList,
            beforeEnter: requireAuth,
        },
        {//현금주문 관리 
            path: '/cpu_cash_order_list',
            component: CPU_CashOrderList,
            beforeEnter: requireAuth,
        },
        {//유저가 코인을 써서 구매한내역
            path: '/cpu_user_buy_products',
            component: CPU_UserBuyProducts,
            beforeEnter: requireAuth,
        },
        {//교환소 — 현금/코인 주문관리 + 코인/현금 상품관리 + 유저상품내역 통합 (탭)
            path: '/cpu_exchange',
            component: CPU_Exchange,
            beforeEnter: requireAuth,
        },
        {//유저가 코인을 써서 구매한내역
            path: '/cpu_game_yt_event_manage',
            component: CPU_Game_YT_EventManage,
            beforeEnter: requireAuth,
        },
        {//전면 이벤트 관리 — 금나르기
            path: '/carrygold_event_noti',
            component: Carrygold_EventNoti,
            beforeEnter: requireAuth,
        },
        {//전면 이벤트 관리
            path: '/cpu_event_noti',
            component: CPU_EventNoti,
            beforeEnter: requireAuth,
        },



        //*************************************************************************************************/
        //* 퀴즈앤 캐시 라우터 설정 
        //*************************************************************************************************/
        {
            path: '/quizcash_dash_board',
            component: QuizCash_Dashboard,
            beforeEnter: requireAuth,
        },
        {//메인 퀴즈 정보 관리
            path: '/quizcash_main_quiz_info',
            component: QuizCash_MainQuizInfo,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/quizcash_user_list',
            component: QuizCash_User_List,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/quizcash_user_info',
            component: QuizCash_User_Info,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/quizcash_mail',
            component: QuizCash_Mail,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/quizcash_coupon',
            component: QuizCash_Coupon,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/quizcash_setting',
            component: QuizCash_Setting,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/quizcash_notice',
            component: QuizCash_Notice,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/quizcash_notice_write',
            component: QuizCash_Notice_Write,
            beforeEnter: requireAuth,
        },
        {//코인상품 관리
            path: '/quizcash_coin_product',
            component: QuizCash_CoinProduct,
            beforeEnter: requireAuth,
        },
        {//현금주문 관리 
            path: '/quizcash_cash_order_list',
            component: QuizCash_CashOrderList,
            beforeEnter: requireAuth,
        },
        {//유저가 코인을 써서 구매한내역
            path: '/quizcash_user_buy_products',
            component: QuizCash_UserBuyProducts,
            beforeEnter: requireAuth,
        },
        {//유저가 코인을 써서 구매한내역
            path: '/quizcash_game_yt_event_manage',
            component: QuizCash_Game_YT_EventManage,
            beforeEnter: requireAuth,
        },
        {//이벤트 롤링 관리
            path: '/quizcash_event_rolling',
            component: QuizCash_EventRolling,
            beforeEnter: requireAuth,
        },
        {//유저 이벤트 검수
            path: '/quizcash_event_verify',
            component: QuizCash_EventVerify,
            beforeEnter: requireAuth,
        },

        //*************************************************************************************************/
        //* 금나르기 라우터 설정 
        //*************************************************************************************************/
        {
            path: '/carrygold_dash_board',
            component: CarryGold_Dashboard,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/carrygold_user_list',
            component: CarryGold_User_List,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/carrygold_user_info',
            component: CarryGold_User_Info,
            beforeEnter: requireAuth,
        },
        {// 애플 계정이전 CS 복구 (AUTH_ID 스왑)
            path: '/carrygold_auth_recover',
            component: CarryGold_Auth_Recover,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/carrygold_mail',
            component: CarryGold_Mail,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/carrygold_coupon',
            component: CarryGold_Coupon,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/carrygold_setting',
            component: CarryGold_Setting,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/carrygold_notice',
            component: CarryGold_Notice,
            beforeEnter: requireAuth,
        },
        {//유저 사전예약 페이지 랜딩
            path: '/carrygold_notice_write',
            component: CarryGold_Notice_Write,
            beforeEnter: requireAuth,
        },
        {//코인상품 관리
            path: '/carrygold_coin_product',
            component: CarryGold_CoinProduct,
            beforeEnter: requireAuth,
        },

        {//현금주문 관리 
            path: '/carrygold_cash_order_list',
            component: CarryGold_CashOrderList,
            beforeEnter: requireAuth,
        },
        {//금교환 주문 관리 
            path: '/carrygold_gold_order_list',
            component: CarryGold_GoldOrderList,
            beforeEnter: requireAuth,
        },
        {//금교환 관리 + 상품관리 통합 (탭)
            path: '/carrygold_gold_exchange',
            component: CarryGold_GoldExchange,
            beforeEnter: requireAuth,
        },
        {//유저가 코인을 써서 구매한내역
            path: '/carrygold_user_buy_products',
            component: CarryGold_UserBuyProducts,
            beforeEnter: requireAuth,
        },
        {//유저가 코인을 써서 구매한내역
            path: '/carrygold_game_yt_event_manage',
            component: CarryGold_Game_YT_EventManage,
            beforeEnter: requireAuth,
        },
        {//개발 유틸리티
            path: '/carrygold_dev_util',
            component: CarryGold_DevUtil,
            beforeEnter: requireAuth,
        },
        {//유저 이벤트 검수 (금리뷰/마켓리뷰)
            path: '/carrygold_notice_goldverify',
            component: CarryGold_Notice_GoldVerify,
            beforeEnter: requireAuth,
        },
        {//금몰빵 룰렛 이벤트
            path: '/carrygold_roulette_event',
            component: CarryGold_RouletteEvent,
            beforeEnter: requireAuth,
        },
        {//채팅 관리
            path: '/carrygold_chat_manage',
            component: CarryGold_ChatManage,
            beforeEnter: requireAuth,
        },


        //*************************************************************************************************/
        //* 단타의 신 라우터 설정
        //*************************************************************************************************/
        {
            path: '/danta_dash_board',
            component: Danta_Dashboard,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_in_progress',
            component: Danta_GameInProgress,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_game_manage',
            component: Danta_GameManage,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_callback_monitor',
            component: Danta_CallbackMonitor,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_user_list',
            component: Danta_UserList,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_game_template',
            component: Danta_GameTemplateManage,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_manual_round_manage',
            component: Danta_ManualRoundManage,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_setting',
            component: Danta_Setting,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_debug_test',
            component: Danta_DebugTest,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_client_list',
            component: Danta_ClientList,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_media_manage',
            component: Danta_MediaManage,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_game_round_detail',
            component: Danta_GameRoundDetail,
            beforeEnter: requireAuth,
        },
        {
            // 단일 진입점 — 내부 v-tabs 로 5개 화면 전환 (#today/#daily/#monthly/#media/#cron)
            path: '/danta_stats',
            component: Danta_StatsIndex,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_stats_today',
            component: Danta_StatsToday,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_stats_daily',
            component: Danta_StatsDaily,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_stats_monthly',
            component: Danta_StatsMonthly,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_stats_media',
            component: Danta_StatsMedia,
            beforeEnter: requireAuth,
        },
        {
            path: '/danta_stats_cron_status',
            component: Danta_StatsCronStatus,
            beforeEnter: requireAuth,
        },

        //*************************************************************************************************/
        //* 프롬프트 마스터 — local/dev 환경 전용 (devCheck 가드)
        //*************************************************************************************************/
        // /prompt_master_setting 은 폐기 — /prombook/setting 사용
        // /prompt_master_list 는 폐기 — /prombook/prompt/list 사용

        //*************************************************************************************************/
        //* 프롬북 라우터 설정
        //*************************************************************************************************/
        // [프롬북]
        { path: '/prombook/prompt/list',      component: Prombook_PromptList,     beforeEnter: requireAuth },
        { path: '/prombook/feed/list',        component: Prombook_FeedList,       beforeEnter: requireAuth },
        { path: '/prombook/user/list',        component: Prombook_UserList,       beforeEnter: requireAuth },
        { path: '/prombook/notice/list',      component: Prombook_NoticeList,     beforeEnter: requireAuth },
        { path: '/prombook/notice/write',     component: Prombook_NoticeWrite,    beforeEnter: requireAuth },
        { path: '/prombook/notice/write/:id', component: Prombook_NoticeWrite,    beforeEnter: requireAuth },
        { path: '/prombook/event/list',       component: Prombook_EventList,      beforeEnter: requireAuth },
        { path: '/prombook/buy_history',      component: Prombook_BuyProductList, beforeEnter: requireAuth },
        { path: '/prombook/setting',          component: Prombook_Setting,        beforeEnter: requireAuth },
        { path: '/prombook/mail',             component: Prombook_Mail,           beforeEnter: requireAuth },
        { path: '/prombook/api_tester',       component: Prombook_ApiTester,      beforeEnter: requireAuth },
        // /prombook/featured 는 Setting 페이지 안 탭으로 통합 (호환을 위해 query 로 진입)
        { path: '/prombook/featured',         redirect: '/prombook/setting?tab=featured' },

        // ===== [포인트공장] =====
        { path: '/pnt_factory/dashboard',        component: PntFactory_Dashboard,       beforeEnter: requireAuth },
        { path: '/pnt_factory/user_list',        component: PntFactory_UserList,        beforeEnter: requireAuth },
        { path: '/pnt_factory/user_info',        component: PntFactory_UserInfo,        beforeEnter: requireAuth },
        { path: '/pnt_factory/mail',             component: PntFactory_Mail,            beforeEnter: requireAuth },
        { path: '/pnt_factory/coupon',           component: PntFactory_Coupon,          beforeEnter: requireAuth },
        { path: '/pnt_factory/notice',           component: PntFactory_Notice,          beforeEnter: requireAuth },
        { path: '/pnt_factory/notice_write',     component: PntFactory_NoticeWrite,     beforeEnter: requireAuth },
        { path: '/pnt_factory/cash_product',     component: PntFactory_CoinProduct,     beforeEnter: requireAuth },
        { path: '/pnt_factory/cash_order',       component: PntFactory_CashOrderList,   beforeEnter: requireAuth },
        { path: '/pnt_factory/user_buy_products',component: PntFactory_UserBuyProducts, beforeEnter: requireAuth },
        { path: '/pnt_factory/event_noti',       component: PntFactory_EventNoti,       beforeEnter: requireAuth },
        { path: '/pnt_factory/setting',          component: PntFactory_Setting,         beforeEnter: requireAuth },
        { path: '/pnt_factory/dev_util',         component: PntFactory_DevUtil,         beforeEnter: requireAuth },
        { path: '/pnt_factory/api_tester',       component: PntFactory_ApiTester,       beforeEnter: requireAuth },
        // [돈만농] — pnt_factory 복사본
        { path: '/mandoora/dashboard',        component: Mandoora_Dashboard,       beforeEnter: requireAuth },
        { path: '/mandoora/user_list',        component: Mandoora_UserList,        beforeEnter: requireAuth },
        { path: '/mandoora/user_info',        component: Mandoora_UserInfo,        beforeEnter: requireAuth },
        { path: '/mandoora/mail',             component: Mandoora_Mail,            beforeEnter: requireAuth },
        { path: '/mandoora/coupon',           component: Mandoora_Coupon,          beforeEnter: requireAuth },
        { path: '/mandoora/notice',           component: Mandoora_Notice,          beforeEnter: requireAuth },
        { path: '/mandoora/notice_write',     component: Mandoora_NoticeWrite,     beforeEnter: requireAuth },
        { path: '/mandoora/cash_product',     component: Mandoora_CoinProduct,     beforeEnter: requireAuth },
        { path: '/mandoora/cash_order',       component: Mandoora_CashOrderList,   beforeEnter: requireAuth },
        { path: '/mandoora/user_buy_products',component: Mandoora_UserBuyProducts, beforeEnter: requireAuth },
        { path: '/mandoora/event_noti',       component: Mandoora_EventNoti,       beforeEnter: requireAuth },
        { path: '/mandoora/setting',          component: Mandoora_Setting,         beforeEnter: requireAuth },
        { path: '/mandoora/dev_util',         component: Mandoora_DevUtil,         beforeEnter: requireAuth },
        { path: '/mandoora/api_tester',       component: Mandoora_ApiTester,       beforeEnter: requireAuth },

        {
            path: '*',
            component: NotFound
        }

    ]
});


export default router;